import { cbChunkMove, chunkArrayGeneric } from "..";
export const batchMove = async (folders, cb, size = 100) => {
    const cbPromises = [];
    if (size <= 0) {
        throw Error('Invalid length');
    }
    chunkArrayGeneric(folders, size).forEach((chunk) => {
        const sources = [];
        chunk.forEach((item) => cbChunkMove(item, sources));
        cbPromises.push(cb(sources));
    });
    return await Promise.all(cbPromises);
};
